// import React, { useState, useEffect, useRef } from "react";
// import DatePicker from "react-datepicker"; // Make sure you have this installed
// import "react-datepicker/dist/react-datepicker.css";

// const CalenderDropdown = ({
//     activeFilter,
//     setActiveFilter,
//     filterDateWise,
//     setFilterDateWise,
//     applyDateFilter,
//     otherDropdownOpen, // boolean prop to know if another dropdown is open
//     labelIcon = "https://cdn-icons-png.flaticon.com/512/747/747310.png",
// }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const ref = useRef();

//     // Toggle dropdown only if no other dropdown is open
//     const toggleDropdown = () => {
//         if (!otherDropdownOpen) {
//             setIsOpen((open) => !open);
//         }
//     };

//     // Close dropdown if clicked outside
//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (ref.current && !ref.current.contains(event.target)) {
//                 setIsOpen(false);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const quickFilters = ["Today", "Yesterday", "Last 7 days", "Last 30 days", "Manual"];

//     // Handle filter selection
//     const handleQuickFilter = (label) => {
//         setActiveFilter(label);
//         if (label !== "Manual") {
//             setIsOpen(false);
//         }
//     };

//     return (
//         <div ref={ref} className="position-relative d-inline-block">
//             <button
//                 onClick={toggleDropdown}
//                 className="btn btn-light dropdown-toggle"
//                 type="button"
//                 aria-expanded={isOpen}
//                 style={{
//                     border: "1px solid #E4E4E7",
//                     backgroundColor: "#FFFFFF",
//                     color: "#1F1F23",
//                     borderRadius: "5px",
//                     padding: "6px 14px",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     minWidth: "220px",
//                     cursor: otherDropdownOpen ? "not-allowed" : "pointer",
//                     opacity: otherDropdownOpen ? 0.6 : 1,
//                 }}
//                 disabled={otherDropdownOpen}
//             >
//                 <img src={labelIcon} alt="Calendar Icon" width={16} height={16} />
//                 <span>
//                     {activeFilter === "Manual"
//                         ? `${filterDateWise.startDate?.toLocaleDateString("en-GB") || "Start"} - ${filterDateWise.endDate?.toLocaleDateString("en-GB") || "End"
//                         }`
//                         : activeFilter || `Jan ${new Date().getFullYear()} - Feb ${new Date().getFullYear()}`}
//                 </span>
//             </button>

//             {isOpen && (
//                 <div
//                     className="position-absolute mt-2 bg-white border shadow p-3"
//                     style={{ zIndex: 1000, width: "50vw", right: 0, borderRadius: "6px" }}
//                 >
//                     <div className="row">
//                         <div className="col-md-3">
//                             <ul className="list-group">
//                                 {quickFilters.map((label) => (
//                                     <li
//                                         key={label}
//                                         className={`list-group-item ${activeFilter === label ? "bg-light rounded" : ""}`}
//                                         style={{ border: "none", cursor: "pointer" }}
//                                         onClick={() => handleQuickFilter(label)}
//                                     >
//                                         {label}
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>

//                         {activeFilter === "Manual" && (
//                             <div className="col-md-9 border-start">
//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <DatePicker
//                                             selected={filterDateWise.startDate}
//                                             onChange={(date) =>
//                                                 setFilterDateWise((prev) => ({
//                                                     ...prev,
//                                                     startDate: date,
//                                                 }))
//                                             }
//                                             inline
//                                         />
//                                     </div>
//                                     <div className="col-md-6">
//                                         <DatePicker
//                                             selected={filterDateWise.endDate}
//                                             onChange={(date) =>
//                                                 setFilterDateWise((prev) => ({
//                                                     ...prev,
//                                                     endDate: date,
//                                                 }))
//                                             }
//                                             inline
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="mt-3 d-flex justify-content-between align-items-center">
//                                     <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                                         <span
//                                             style={{
//                                                 backgroundColor: "#343a40",
//                                                 color: "#fff",
//                                                 padding: "6px 12px",
//                                                 borderRadius: "6px",
//                                                 fontSize: "14px",
//                                             }}
//                                         >
//                                             {filterDateWise.startDate?.toLocaleDateString("en-GB")}
//                                         </span>
//                                         <span style={{ fontSize: "16px", color: "#000" }}>→</span>
//                                         <span
//                                             style={{
//                                                 backgroundColor: "#343a40",
//                                                 color: "#fff",
//                                                 padding: "6px 12px",
//                                                 borderRadius: "6px",
//                                                 fontSize: "14px",
//                                             }}
//                                         >
//                                             {filterDateWise.endDate?.toLocaleDateString("en-GB")}
//                                         </span>
//                                     </div>
//                                     <button className="btn btn-dark" onClick={() => applyDateFilter()}>
//                                         Apply
//                                     </button>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CalenderDropdown;


import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CalenderDropdown = ({
    activeFilter,
    setActiveFilter,
    filterDateWise,
    setFilterDateWise,
    applyDateFilter,
    buttonStyle,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const currentMonthRangeLabel = (() => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return `${start.toLocaleDateString("en-GB")} - ${end.toLocaleDateString("en-GB")}`;
    })();

    const toggleDropdown = () => setIsOpen((open) => !open);

    // Handle outside click to close dropdown
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const quickFilters = ["Today", "Yesterday", "Last 7 days", "Last 30 days", "Manual"];

    const handleQuickFilter = (label) => {
        const now = new Date();
        let start = new Date(now);
        let end = new Date(now);

        switch (label) {
            case "Today":
                break;
            case "Yesterday":
                start.setDate(now.getDate() - 1);
                end.setDate(now.getDate() - 1);
                break;
            case "Last 7 days":
                start.setDate(now.getDate() - 6);
                break;
            case "Last 30 days":
                start.setDate(now.getDate() - 29);
                break;
            case "Manual":
                setActiveFilter("Manual");
                return;
            default:
                setActiveFilter(label);
                return;
        }

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        setFilterDateWise({ startDate: start, endDate: end });
        setActiveFilter(label);
        // Callers may accept an argument; extra args are ignored in JS
        applyDateFilter?.({ startDate: start, endDate: end });
        setIsOpen(false);
    };

    return (
        <div ref={ref} className="position-relative d-inline-block">
            <button
                onClick={toggleDropdown}
                className="btn"
                type="button"
                aria-expanded={isOpen}
                style={{
                    border: "1px solid #E4E4E7",
                    backgroundColor: "#FFFFFF",
                    color: "#1F1F23",
                    borderRadius: "5px",
                    padding: "6px 14px",
                    fontSize: "12px",
                    fontWeight: "500",
                    boxShadow: isOpen
                        ? "0px 0px 4px rgba(79, 70, 229, 0.5)"
                        : "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    transition:
                        "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out",
                    minWidth: "100px",
                    textAlign: "left",
                    ...buttonStyle,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "8px",
                        fontSize: "12px",
                    }}
                >
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                            alt="Calendar Icon"
                            width={16}
                            height={16}
                        />
                        <span>
                            {activeFilter === "Manual"
                                ? `${filterDateWise.startDate?.toLocaleDateString("en-GB") || "Start"} - ${filterDateWise.endDate?.toLocaleDateString("en-GB") || "End"
                                }`
                                : activeFilter || currentMonthRangeLabel}
                        </span>
                    </span>
                    <span style={{ fontSize: "12px", marginLeft: "8px" }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="black"
                            viewBox="0 0 16 16"
                        >
                            <path
                                fillRule="evenodd"
                                d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                            />
                        </svg>
                    </span>
                </div>
            </button>

            {isOpen && (
                <div
                    className="position-absolute mt-2 bg-white border shadow p-3"
                    style={{ zIndex: 1000, width: "50vw", right: 0, borderRadius: "6px" }}
                >
                    <div className="row">
                        <div className="col-md-3">
                            <ul className="list-group">
                                {quickFilters.map((label) => (
                                    <li
                                        key={label}
                                        className={`list-group-item ${activeFilter === label ? "bg-light rounded" : ""}`}
                                        style={{ border: "none", cursor: "pointer" }}
                                        onClick={() => handleQuickFilter(label)}
                                    >
                                        {label}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {activeFilter === "Manual" && (
                            <div className="col-md-9 border-start">
                                <div className="row">
                                    <div className="col-md-6">
                                        <DatePicker
                                            selected={filterDateWise.startDate}
                                            onChange={(date) => {
                                                if (!date) return;
                                                const start = new Date(date);
                                                start.setHours(0, 0, 0, 0);
                                                setFilterDateWise((prev) => ({
                                                    ...prev,
                                                    startDate: start,
                                                }));
                                            }}
                                            inline
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <DatePicker
                                            selected={filterDateWise.endDate}
                                            onChange={(date) => {
                                                if (!date) return;
                                                const end = new Date(date);
                                                end.setHours(23, 59, 59, 999);
                                                setFilterDateWise((prev) => ({
                                                    ...prev,
                                                    endDate: end,
                                                }));
                                            }}
                                            inline
                                        />
                                    </div>
                                </div>
                                <div className="mt-3 d-flex justify-content-between align-items-center">
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <span
                                            style={{
                                                backgroundColor: "#343a40",
                                                color: "#fff",
                                                padding: "6px 12px",
                                                borderRadius: "6px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {filterDateWise.startDate?.toLocaleDateString("en-GB")}
                                        </span>
                                        <span style={{ fontSize: "16px", color: "#000" }}>→</span>
                                        <span
                                            style={{
                                                backgroundColor: "#343a40",
                                                color: "#fff",
                                                padding: "6px 12px",
                                                borderRadius: "6px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {filterDateWise.endDate?.toLocaleDateString("en-GB")}
                                        </span>
                                    </div>
                                    <button
                                        className="btn btn-dark"
                                        onClick={() => {
                                            applyDateFilter?.();
                                            setIsOpen(false);
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CalenderDropdown;
